import script from "./GraphChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./GraphChart.vue?vue&type=script&setup=true&lang=ts"

import "./GraphChart.vue?vue&type=style&index=0&id=56b6e69c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56b6e69c"]])

export default __exports__